import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const CmaResultsPage = lazy(() => import('../../pages/cma-results/cma-results'));

// ----------------------------------------------------------------------

export const cmaResultsRoutes: RouteObject[] = [
  {
    path: 'cma-results/:requestId',
    element: CONFIG.auth.skip ? (
      <Suspense fallback={<LoadingScreen />}>
        <DashboardLayout>
          <CmaResultsPage />
        </DashboardLayout>
      </Suspense>
    ) : (
      <AuthGuard>
        <Suspense fallback={<LoadingScreen />}>
          <DashboardLayout>
            <CmaResultsPage />
          </DashboardLayout>
        </Suspense>
      </AuthGuard>
    ),
  },
];
